jQuery(document).ready(function($){
	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-wrapper img').on('click', function(){
		const index = $(this).attr('index');
		const prevIndex = $(this).attr('prev');
		const nextIndex = $(this).attr('next');

		const modalSrc = $(this).attr('modal_src');
		const parentDiv = $(this).closest('.scfe-block-wrapper.google-drive-image-gallery');

		parentDiv.find('.gallery-modal-img > img').attr('src', modalSrc);
		parentDiv.find('.gallery-modal-img > .prev-arrow').attr('img-target', prevIndex);
		parentDiv.find('.gallery-modal-img > .next-arrow').attr('img-target', nextIndex);
		parentDiv.find('.gallery-modal-wrapper').addClass('showing');
		console.log(modalSrc);
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-bg').on('click', function(){
		const parentDiv = $(this).closest('.gallery-modal-wrapper');

		parentDiv.find('img').attr('src', '').addClass('not-loaded');
		parentDiv.removeClass('showing');
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img').on('click', function(e){
		const parentDiv = $(this).closest('.gallery-modal-wrapper');

		parentDiv.find('img').attr('src', '').addClass('not-loaded');
		parentDiv.removeClass('showing');
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img img').on('click', function(e){
		e.stopPropagation();
	});

	$('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img .fas').on('click', function(e){
		e.stopPropagation();

		const imgTargetId = $(this).attr('img-target');

		const parentBlock = $(this).closest('.scfe-block-wrapper.google-drive-image-gallery');
		const parentDiv = $(this).closest('.gallery-modal-img');
		const galleryWrapper = parentBlock.find('.gallery-wrapper');

		const imgTarget = galleryWrapper.find('img[index="' + imgTargetId + '"]');
		const imgSrc = imgTarget.attr('modal_src');
		const prevIndex = imgTarget.attr('prev');
		const nextIndex = imgTarget.attr('next');
		parentDiv.find('.prev-arrow').attr('img-target', prevIndex);
		parentDiv.find('.next-arrow').attr('img-target', nextIndex);
		parentDiv.find('img').attr('src', imgSrc);
	});

	const galleryImg = document.querySelector('.scfe-block-wrapper.google-drive-image-gallery .gallery-modal-wrapper .gallery-modal-img img');
	console.log(galleryImg)
	if(galleryImg !== null) {
		galleryImg.addEventListener('load', () => {
			galleryImg.classList.remove('not-loaded');
		});
	}
});